<div class="hha-note-template__container">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div class="hha-note-template__available-variables" fxLayout="row" fxLayoutAlign="start center"></div>

    <button mat-icon-button matTooltip="Available Note Templates" [matMenuTriggerFor]="menu">
      <mat-icon>quickreply</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button
        *ngFor="let template of availableNoteTemplates"
        mat-menu-item
        (click)="onTemplateSelect(template.metadata)"
      >
        {{ template.text }}
      </button>
    </mat-menu>
  </div>

  <app-mat-textarea-input
    name="noteTemplate"
    [label]="fieldLabels['noteTemplate']"
    [formControl]="noteFormControl"
    [hintLabel]="
      'Available Note Variables: {{from_number}}, {{from_name}}, {{to_number}}, {{to_name}}, {{call_start}}, {{call_duration}}, {{call_url}}, {{call_summary}} (after transcription).'
    "
    [formControl]="noteFormControl"
    [rows]="4"
  ></app-mat-textarea-input>
</div>
